// The browser platform with a compiler
// Application is using dynamic bootstrapping wit JIT (Just-In-Time) compiler
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// The app module
import { AppModule } from './AppModule';
import {enableProdMode} from '@angular/core';

enableProdMode();

// Combine and launch the module
platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./src/auth/main.ts